import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../../common/theme/ISpcTheme';

export type FeatureAccessoryClasses =
  | 'container'
  | 'selectedFeatureContainer'
  | 'itemContainer'
  | 'detailsContainer'
  | 'moreDetailsToggle'
  | 'checkbox'
  | 'radio'
  | 'imageUnavailable'
  | 'detailsName'
  | 'featureAccessoryPrice'
  | 'detailsSection'
  | 'detailsWrapper'
  | 'detailsSectionWrapper'
  | 'inputSectionPortrait'
  | 'inputSectionLandscape'
  | 'itemContainerDisabled'
  | 'backdrop';

const featureAccessoryStyles = makeStyles<ISpcTheme, FeatureAccessoryClasses>(
  ({ palette }) => ({
    container: {
      marginBottom: '20px',
      padding: '10px 10px 0',
    },
    selectedFeatureContainer: {},
    itemContainer: {
      display: 'flex',
      backgroundColor: palette.background.alternate,
    },
    detailsContainer: {
      padding: '10px 10px 20px',
    },
    checkbox: {
      padding: 0,
    },
    radio: {
      paddingBottom: 0,
    },
    moreDetailsToggle: {
      color: palette.primary.main,
    },
    imageUnavailable: {
      maxWidth: '100%',
      maxHeight: '100%',
    },
    detailsName: {},
    featureAccessoryPrice: {},
    detailsSection: {},
    inputSectionPortrait: {
      marginTop: '40px',
    },
    inputSectionLandscape: {
      marginTop: '20px',
    },
    itemContainerDisabled: {
      pointerEvents: 'none',
      position: 'relative',
    },
    detailsWrapper: {},
    detailsSectionWrapper: {},
    backdrop: {
      position: 'absolute',
      background: `repeating-linear-gradient(
        -45deg,
        ${palette.grey[400]},
        ${palette.grey[400]} 10px,
        ${palette.grey[900]} 10px,
        ${palette.grey[900]} 20px
      )`,
      width: '100%',
      height: '100%',
      opacity: 0.05,
      zIndex: 1,
      cursor: 'not-allowed',
      borderRadius: 'inherit',
    },
  }),
  { name: 'Customise_Feature_Accessory' },
);

export default featureAccessoryStyles;
